var map = {
	"./Annual Day.png": 21190,
	"./Convocation Day.png": 94432,
	"./E-Horizon-2025.jpg": 76028,
	"./First Year Inaugural Function.JPG": 30805,
	"./ITConference.jpeg": 36661,
	"./KEC 30 hours Hackathon.jpg": 22907,
	"./Kongu Trophy.png": 92347,
	"./Pongal Celebration.jpg": 65596,
	"./Silver Jubilee Meet.JPG": 92516,
	"./Sports Day.jpg": 97310,
	"./Swaram 2025.jpg": 48163,
	"./Techno - Cultural Fest.JPG": 41532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42670;